// extracted by mini-css-extract-plugin
export default {"loaderContainer":"LoadPage_loaderContainer__2Ha1h","contentContainer":"LoadPage_contentContainer__U7evm"};